import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import image1 from "../images/image1.jpg";
import image2 from "../images/image2.jpg";
import image3 from "../images/image3.jpg";


// const images = [image1, image2, image3];
const SliderComponent = () => {

    const images = [
        require("../images/image1.jpg"),
        require("../images/image2.jpg"),
        require("../images/image3.jpg"),
      ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true, 
  };


  return (
  
        <Box sx={{ position: "relative", width: "100%", height: "300px" }}>
          <Slider {...settings}>
            {images.map((image, index) => (
              <Box key={index}>
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "400px",
                    objectFit: "cover",
                  }}
                />
              </Box>
            ))}
          </Slider>
    
          <Box
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            }}
          >
            <Typography variant="h3" component="h1" sx={{ fontWeight: "bold" }}>
            Your Space, Our Responsibility
            </Typography>
            <Typography variant="h6" component="p" sx={{ mt: 4 }}>
            {/* Trusted partner for sparkling airbnb spaces. */}
            Connect with trusted, professional cleaners to ensure your property always looks its best
            </Typography>
          </Box>
        </Box>
      )
};

export default SliderComponent;